import styled from 'styled-components';

export const Item = styled.div`
a{
    display:flex;
    flex-direction:column;
    justify-content:flex-start;
    align-items:center;
    border:1px solid #f0d27a;
    box-shadow:0 10px 24px rgba(15, 23, 42, 0.08);
    margin:10px;
    text-decoration:none;
    padding:10px;
    border-radius:5px;
    color:#000;
    background-color:#FFF;
    height:auto;
    transition:all ease .2s;
    
    
    &:hover {
        background-color:#fff8e6;
        border:1px solid #ff2018;
    }

    .AreaDetail{
        display:flex;
        flex-direction:column;
        justift-content:center;
        align-items:center;
        height:auto;
    }

    .itemImage img{
        width:100%;
        border-radius:10px;
    }

    .itemName {
        font-size:16px;
        color:#6b6b6b;
        font-family:Omnes, sans-serif;
        text-align:center;
        height:50px;
    }
    .itemPrice{
        margin-top:5px;
    }

    .Add{
        display:flex;
        justify-content:center;
        align-items:center;
        width:80px;
        height:30px;
        border-radius:14px;
        background:linear-gradient(135deg, #ff2018 0%, #ffcc00 180%);
        font-weight:bold;
        font-size:12px;
        color:#FFF;
        font-family:Omnes, sans-serif;
    }
}

@media (max-width:800px){
    a{
        height:auto;
    }
}


@media (max-width:600px){
    a{
        height:auto;
    }
}
`;